export default "__VITE_ASSET__K2ZIw2QD__"